import { QueryObserverResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { createContext, Dispatch, SetStateAction } from 'react';
import { Order } from 'utils/types';

type CartContextType = {
  openCart: () => void;
  closeCart: () => void;
  isCartOpen: boolean;
  order?: Order;
  refetchOrder?: () => Promise<
    QueryObserverResult<AxiosResponse<Order>, unknown>
  >;
  isFetchingOrder: boolean;
  cartErrors: string[];
  setCartErrors: Dispatch<SetStateAction<string[]>>;
  resetOrder: () => void;
};

export const cartContextDefaultValues: CartContextType = {
  openCart: () => {},
  closeCart: () => {},
  isCartOpen: false,
  order: undefined,
  isFetchingOrder: false,
  cartErrors: [],
  setCartErrors: () => {},
  resetOrder: () => {},
};

const CartContext = createContext<CartContextType>(cartContextDefaultValues);

export default CartContext;
